<template>
  <div class="ly-card posts-content-detail">
    <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm">
      <template v-slot:attach_url="{ formData }">
        <div class="media-content" v-if="defaultFormItem.attach_url">
          <div v-for="(item, index) in formData.attach_url" :key="item" class="media-item">
            <img v-if="isImage" :src="`${baseUrl}/${item}`" width="200px" />
            <video v-else :src="`${baseUrl}/${item}`" controls="controls" width="200px"></video>
            <i class="el-icon-close" @click="removeMedia(index)"></i>
          </div>
        </div>
        <div class="media-content" v-else>
            <div v-for="(item, index) in formData.attach_url" :key="item" class="media-item">
              <img v-if="type === 'image'" :src="`${baseUrl}/${item}`" width="200px" />
              <video v-if="type === 'video'" :src="`${baseUrl}/${item}`" controls="controls" width="200px"></video>
              <i class="el-icon-close" @click="removeMedia(index)"></i>
          </div>
        </div>
        <upload
          v-show="canUpload"
          ButtonText="上传附件"
          :action="action"
          :before="before"
          tips="至多9张图片或一个视频"
          @successCBK="value => attachChange(value, formData)"
          :accept="`${picAcc},${videoAcc}`"
        />
      </template>
    </ly-form>
    <div class="buttom">
      <el-button @click.native="back">返 回</el-button>
      <el-button @click.native="addSubmit" type="primary">保 存</el-button>
    </div>
  </div>
</template>
<script>
import cPosts from '@/api/cPosts';
import cUser from '@/api/cUser';
import LyForm from '@/components/LyForm';
import { postsFormItem } from '@/utils/communityFormConfig';
import Upload from '@/components/cUpload';
import localCache from '@/utils/localCache';
import pattern from '@/utils/pattern';

export default {
  name: 'newBriefedDetail',
  components: {
    Upload,
    LyForm
  },
  data() {
    return {
      defaultFormItem: {
        // is_topping: false,
        // is_essence: false
      },
      formKeys: postsFormItem,
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      action: cUser.cUpload,
      picAcc: '.jpg, .jpeg, .png, .gif, .bmp',
      videoAcc: '.mp4',
      attach_url: [],
      type: '',
      baseUrl: '',
      formData: {}
    };
  },
  async mounted() {
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
    this.init();
  },
  computed: {
    canUpload() {
      if (!this.attach_url || this.attach_url.length === 0) return true;
      return (
        (this.type === 'video' && this.attach_url.length === 0) || (this.type === 'image' && this.attach_url.length < 9)
      );
    },
    content_id() {
      if (!this.$route.params.id) return -1;
      return parseInt(this.$route.params.id, 10);
    },
    isAdd() {
      return this.content_id === -1;
    },
    isImage() {
      if (this.defaultFormItem.attach_url) {
        return pattern.IS_IMAGE.test(this.defaultFormItem.attach_url[0]);
      }
      return false;
    }
  },
  activated() {
    // this.$refs.lyForm.resetFields();
    this.init();
  },
  methods: {
    async init() {
      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
      if (this.isAdd) {
        this.reset();
      } else {
        this.defaultFormItem = localCache.getItem('contentInfo');
        this.formData = this.defaultFormItem;
      }
    },
    async addSubmit() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (!valid) return;
      let res = null;
      if (this.isAdd) {
        res = await cPosts.addPosts({
          params: {
            ...data,
            title: '中国儿童中心',
            attach_type: this.type === 'image' ? 1 : 2
          },
          methold: 'post'
        });
      } else {
        res = await cPosts.updatePosts({
          params: {
            ...data,
            title: '中国儿童中心',
            attach_type: this.type === 'image' ? 1 : 2
          },
          methold: 'post',
          post_id: this.content_id
        });
      }
      if (res) {
        this.$message.success(res.msg || '发帖成功！');
        this.back();
      }
    },
    reset() {
      this.defaultFormItem = {
        is_topping: false,
        is_essence: false
      };
      // this.$refs.lyFormBriefed.resetFields();
      if (this.$refs.lyFormBriefed) this.$refs.lyFormBriefed.resetFields();
    },
    back() {
      this.$store.dispatch('tagsView/delView', this.$route).then(() => {
        this.$router.replace({ path: `/${this.$route.params.user_id}/community/content` });
      });
    },
    attachChange(value, formData) {
      this.formData = formData;
      if (formData.attach_url) {
        formData.attach_url.push(value[0].url);
      } else {
        // eslint-disable-next-line no-param-reassign
        formData.attach_url = [value[0].url];
      }
      this.attach_url = formData.attach_url;
    },
    before(file) {
      if (this.attach_url.length === 0) {
        [this.type] = file.type.split('/');
      }
      if (file.type.includes('video') && this.type === 'image') {
        this.$message.warning('请上传正确格式的图片！');
        return false;
      }
      return true;
    },
    removeMedia(index) {
      this.formData.attach_url.splice(index, 1);
      if (this.formData.attach_url.length === 0) {
        this.type = 'image';
      }
    }
  }
};
</script>
<style lang="less">
.posts-content-detail {
  .ly-form .el-input__inner {
    width: 220px;
  }
  .content-width-full {
    .el-form-item {
      width: 100%;
      .el-form-item__content {
        width: 100%;
      }
    }
  }
  .el-textarea__inner {
    width: 600px;
  }
  .media-content {
    display: flex;
  }
  .media-item {
    position: relative;
    font-size: 20px;
    color: @danger;
    margin-right: 20px;
    margin-bottom: 20px;
    > .el-icon-close {
      display: block;
      position: absolute;
      top: -10px;
      right: -10px;
      background: #f3f3f3;
      cursor: pointer;
    }
  }
}
</style>
